module.exports = __webpack_public_path__ + "img/envelope-at-fill.9cf84d15.svg";